<div
        *ngIf="(profileState | async).profileProgress !== null && (profileState | async).profileProgress[type()] !== undefined"
        class=" loading-bg"
>
  <div class="loading-bar" [ngStyle]="{width: 'calc(' + (profileState | async).profileProgress[type()].percent + '%)'}"></div>
</div>
<div
     *ngIf="(profileState | async).profileProgress !== null && (profileState | async).profileProgress[type()] !== undefined"
     [class]="(profileState | async).profileProgress[type()].percent == 0 ? 'opacity' : ''">
  <ng-content></ng-content>
</div>
